exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input.month[data-v-5fd455ea],input.year[data-v-5fd455ea]{display:inline-block;max-width:32px;width:auto;padding-right:0;padding-left:0;letter-spacing:1px}input.month[data-v-5fd455ea]{margin-left:2px}input.month.with-value[data-v-5fd455ea],input.year.with-value[data-v-5fd455ea]{max-width:20px}.expiry-container[data-v-5fd455ea]{padding-left:10px}[data-v-5fd455ea]::-webkit-input-placeholder{color:#afb2b7;font-weight:300}[data-v-5fd455ea]:-moz-placeholder,[data-v-5fd455ea]::-moz-placeholder{color:#afb2b7;font-weight:300}[data-v-5fd455ea]:-ms-input-placeholder{color:#afb2b7;font-weight:300}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5fd455ea&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ExpiryComponent.vue
// module id = 59
// module chunks = 0